import formattedData from 'utils/formattedData';
import { formatTextTitle } from 'utils/formatText';

import type { IActivityHeader } from './interfaces/IActivityHeader';

import styles from './scss/ActivityHeader.module.scss';

function ActivityHeader({
  firstName,
  lastName,
  activityType,
  createdAt,
}: IActivityHeader) {
  return (
    <div className={styles.commentHeader}>
      <div className={styles.commentAuthor}>
        <div className={styles.commentAuthorInfo}>
          <strong>{`${firstName} ${lastName}`}</strong>
          {activityType ? <span className={styles.activityType}>{formatTextTitle(activityType)}</span> : null}
        </div>
        <span className={styles.commentDate}>{formattedData(createdAt, true)}</span>
      </div>
    </div>
  );
}

export default ActivityHeader;
